var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CoreTable", {
        attrs: { emptyMessage: _vm.emptyMessage, dataLoading: _vm.dataLoading },
        scopedSlots: _vm._u([
          {
            key: "headers",
            fn: function () {
              return [
                _c("th", [_vm._v(_vm._s(_vm.coreString("fullNameLabel")))]),
                _c("th", [_vm._v(_vm._s(_vm.coreString("usernameLabel")))]),
                _vm.hasMultipleFacilities
                  ? _c("th", [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.coreString("facilityLabel")) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
                _c("th"),
              ]
            },
            proxy: true,
          },
          {
            key: "tbody",
            fn: function () {
              return [
                _c(
                  "tbody",
                  _vm._l(_vm.facilityUsers, function (user) {
                    return _c("tr", { key: user.id }, [
                      _c(
                        "td",
                        [
                          _c("KLabeledIcon", {
                            attrs: { label: _vm.fullNameLabel(user) },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "icon",
                                  fn: function () {
                                    return [
                                      Boolean(_vm.getPermissionType(user.id))
                                        ? _c("PermissionsIcon", {
                                            attrs: {
                                              permissionType:
                                                _vm.getPermissionType(user.id),
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                      _c("td", [
                        _c(
                          "span",
                          { staticClass: "maxwidth", attrs: { dir: "auto" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(user.username) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]),
                      _vm.hasMultipleFacilities
                        ? _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "maxwidth",
                                attrs: { dir: "auto" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.memoizedFacilityName(user.facility)
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _c(
                        "td",
                        { staticClass: "btn-col" },
                        [
                          _c("KButton", {
                            staticStyle: { margin: "6px" },
                            attrs: {
                              appearance: "flat-button",
                              text: _vm.permissionsButtonText(user),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.goToUserPermissionsPage(user.id)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }